
// app/javascript/controllers/contentcategories_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["relevanceSelect", "contentCategorySelect"]

    connect() {
        console.log("Contentcategories controller connected")  // HILFT DIR!
    }

    relevanceChanged() {
        console.log("Relevance changed!") // Test
        const relevance = this.relevanceSelectTarget.value

        fetch(`/contentcategories/filtered?relevance=${encodeURIComponent(relevance)}`)
            .then(response => response.json())
            .then(data => {
                this.contentCategorySelectTarget.innerHTML = ""
                const placeholder = document.createElement("option")
                placeholder.textContent = "Bitte auswählen"
                placeholder.value = ""
                this.contentCategorySelectTarget.appendChild(placeholder)

                data.forEach(category => {
                    const option = document.createElement("option")
                    option.value = category.id
                    option.textContent = category.name
                    this.contentCategorySelectTarget.appendChild(option)
                })
            })
            .catch(error => {
                console.error("Error loading content categories:", error)
            })
    }
}